document.addEventListener("DOMContentLoaded", () => {

    // Calculates the maximum height among all content items in a list
    function getAchievementsMaxHeight(items) {
        let maxHeight = 0;

        items.forEach((item) => {
            const content = item.querySelector('.achievements__item-content');
            if (content) {
                // Reset min-height before measuring to get the natural height
                item.style.minHeight = 'auto';
                const height = content.clientHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            }
        });

        return maxHeight;
    }

    // Main function to update cards height
    function calcAchievementsHeight() {
        const lists = document.querySelectorAll('.achievements__list');

        if (!lists.length) return;

        lists.forEach((list) => {
            const items = list.querySelectorAll('.achievements__item');
            const maxHeight = getAchievementsMaxHeight(items);

            if (maxHeight === 0) return;

            items.forEach((item) => {
                const itemFront = item.querySelector('.achievements__item-front');

                if (itemFront) {
                    const style = window.getComputedStyle(itemFront);
                    // Extract padding to ensure content fits perfectly
                    const paddingTop = parseFloat(style.paddingTop) || 0;
                    const paddingBottom = parseFloat(style.paddingBottom) || 0;

                    item.style.minHeight = `${maxHeight + paddingTop + paddingBottom}px`;
                }
            });
        });
    }

    function getIndustriesMaxHeight(items) {
        let maxHeight = 0;

        items.forEach((item) => {
            const content = item.querySelector('.industries__item-content');
            if (content) {
                // Reset min-height before measuring to get the natural height
                item.style.minHeight = 'auto';
                const height = content.clientHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            }
        });

        return maxHeight;
    }

    function calcIndustriesHeight() {
        const lists = document.querySelectorAll('.industries__list');

        if (!lists.length) return;

        lists.forEach((list) => {
            const items = list.querySelectorAll('.industries__item');
            const maxHeight = getIndustriesMaxHeight(items);

            if (maxHeight === 0) return;

            items.forEach((item) => {
                const itemFront = item.querySelector('.industries__item-front');

                if (itemFront) {
                    const style = window.getComputedStyle(itemFront);
                    // Extract padding to ensure content fits perfectly
                    const paddingTop = parseFloat(style.paddingTop) || 0;
                    const paddingBottom = parseFloat(style.paddingBottom) || 0;
                    item.style.minHeight = `${maxHeight + paddingTop + paddingBottom}px`;
                }
            });
        });
    }

    // Optimization: run when the browser is idle
    const runWhenIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));

    runWhenIdle(() => {
        calcAchievementsHeight();
        calcIndustriesHeight();
    });

    // Handle window resize with a debounce timer
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            calcAchievementsHeight();
            calcIndustriesHeight();
        }, 200);
    });
});